import React from "react"
import { CustomServerSideReactTableNew } from "components/utility"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { maintainServiceStatusTypes, findTypeValueByKey } from "utils/types"
import {
  GET_MAINTAIN_SERVICES,
  DELETE_MAINTAIN_SERVICE,
  SUM_MAINTAIN_SERVICE,
  GET_TABLE_FIELDS
} from "../gql"

document.body.scrollTop = 0 // For Safari
document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

const MaintainServiceContainer = (props) => {
  const objectName = "叫修紀錄"

  useBread({ to: props.match.url, name: "叫修紀錄維護" }, true)

  const columnDefs = [
    { title: "公司名稱", name: "companyName", type: "input" },
    { title: "裝置名稱", name: "deviceName", type: "input" },
    { title: "裝置編號", name: "deviceNumber", type: "input" },
    {
      title: "狀態",
      name: "status",
      type: "select",
      options: maintainServiceStatusTypes
    },
    { title: "描述", name: "description", type: "input" }
  ]

  const fieldsDefinition = () => {
    return [
      {
        id: "companyName",
        Header: "公司",
        style: columStyle,
        accessor: (data) => data.company?.name,
        width: 200
      },
      {
        id: "companyDeviceName",
        Header: "裝置名稱",
        style: columStyle,
        accessor: (data) => data.companyDevice?.device?.name,
        width: 200
      },
      {
        id: "companyDeviceNumber",
        Header: "裝置編號",
        style: columStyle,
        accessor: (data) => data.companyDevice?.device?.number,
        width: 200
      },
      {
        id: "status",
        Header: "狀態",
        style: columStyle,
        accessor: "status",
        width: 150
      }
    ]
  }

  return (
    <CustomServerSideReactTableNew
      columnDefs={columnDefs}
      queryObjectGql={GET_MAINTAIN_SERVICES}
      sumTotalQueryObjectGql={SUM_MAINTAIN_SERVICE}
      fieldsDefGql={GET_TABLE_FIELDS}
      objectRoute={props.match.url}
      hasCreateButton={true}
      hasEditButton={true}
      hasDeleteButton={true}
      fieldsDef={fieldsDefinition(props)}
      columStyle={columStyle}
    />
  )
}

const columStyle = { whiteSpace: "unset", textAlign: "center" }

export default withBreadcrumb(MaintainServiceContainer)
